import { createAction } from 'redux-actions';
import {
  CLOSE_CHANGE_PASSWORD_MODAL,
  CLOSE_DELETE_VIDEO_MODAL,
  CLOSE_EDIT_VIDEO_MODAL,
  CLOSE_MODAL,
  CLOSE_MONITORING_REFRESH_MODAL,
  CLOSE_MONITORING_RESTART_MODAL,
  CLOSE_RESET_PASSWORD_MODAL,
  CLOSE_SELECT_VIDEO_MODAL,
  OPEN_CHANGE_PASSWORD_MODAL,
  OPEN_DELETE_VIDEO_MODAL,
  OPEN_EDIT_VIDEO_MODAL,
  OPEN_MODAL,
  OPEN_MONITORING_REFRESH_MODAL,
  OPEN_MONITORING_RESTART_MODAL,
  OPEN_RESET_PASSWORD_MODAL,
  OPEN_SELECT_VIDEO_MODAL,
  TOOGLE_WORKOUT_PROGRAM_MODAL,
} from './types';

export const openModal = createAction(OPEN_MODAL);
export const closeModal = createAction(CLOSE_MODAL);

export const toogleWorkoutProgramModal = createAction(
  TOOGLE_WORKOUT_PROGRAM_MODAL
);

export const openSelectVideoModal = createAction(OPEN_SELECT_VIDEO_MODAL);
export const closeSelectVideoModal = createAction(CLOSE_SELECT_VIDEO_MODAL);

export const openChangePasswordModal = createAction(OPEN_CHANGE_PASSWORD_MODAL);
export const closeChangePasswordModal = createAction(
  CLOSE_CHANGE_PASSWORD_MODAL
);

export const openEditVideoModal = createAction(OPEN_EDIT_VIDEO_MODAL);
export const closeEditVideoModal = createAction(CLOSE_EDIT_VIDEO_MODAL);

export const openDeleteVideoModal = createAction(OPEN_DELETE_VIDEO_MODAL);
export const closeDeleteVideoModal = createAction(CLOSE_DELETE_VIDEO_MODAL);

export const openMonitoringRefreshModal = createAction(
  OPEN_MONITORING_REFRESH_MODAL
);
export const closeMonitoringRefreshModal = createAction(
  CLOSE_MONITORING_REFRESH_MODAL
);

export const openMonitoringRestartModal = createAction(
  OPEN_MONITORING_RESTART_MODAL
);
export const closeMonitoringRestartModal = createAction(
  CLOSE_MONITORING_RESTART_MODAL
);
export const openResetPasswordModal = createAction(OPEN_RESET_PASSWORD_MODAL);
export const closeResetPasswordModal = createAction(CLOSE_RESET_PASSWORD_MODAL);
